import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { redirectToLogin } from "../utils/auth";
import { Loading } from "../Components/Loading/Loading";
import { JbmTicket } from "./JbmTicket";
import { RcsTicket } from "./RcsTicket";
import { useTicketContext } from "../context/TicketContext";

// Route /Ticket/:ticketID. Fetches the ticket and renders the detail component
// for its clientType. The ticket's own tag decides (not a URL param), so it
// can't be manipulated by editing the URL.
export const Ticket = () => {
  const { ticketID } = useParams();
  const [clientType, setClientType] = useState(null);
  const [loading, setLoading] = useState(true);
  const authToken = localStorage.getItem("authToken");
  const { setTicketClientType } = useTicketContext();

  useEffect(() => {
    if (!authToken) {
      redirectToLogin();
      return;
    }
    fetch(`${process.env.REACT_APP_BACKEND_URL}/API/V2/Tickets/${ticketID}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${authToken}`,
      },
    })
      .then((r) => {
        if (r.status === 401) {
          redirectToLogin();
          return null;
        }
        return r.json();
      })
      .then((data) => {
        if (data && !data.error) {
          setClientType(data.clientType);
          setTicketClientType(data.clientType || "JBM");
        }
        setLoading(false);
      })
      .catch((err) => {
        console.error("Ticket lookup error:", err);
        setLoading(false);
      });

    // Clear the section hint when leaving the ticket page.
    return () => setTicketClientType(null);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ticketID]);

  if (loading) return <Loading />;
  return clientType === "RCS" ? <RcsTicket /> : <JbmTicket />;
};
